import { useLocation, useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import useScrollDetection from "../../../hooks/useScrollDetection";
import { IoMdCopy } from "react-icons/io";
import { useNotification } from "../../../components/context/NotificationContext";
import { checkPaymentTransactionJwt } from "../../../services/transactionApi";
import { useQuery } from "@tanstack/react-query";
import Success from "../../../assets/success.png";
import { useState } from "react";

const CheckoutPaymentSuccess = () => {
  const navigate = useNavigate();
  const isScrolled = useScrollDetection(5);
  const { showNotification } = useNotification();
  const location = useLocation();
  const { invoice_number } = location.state || "";
  const machineId = localStorage.getItem("MachineId");

  const [copied, setCopied] = useState(false);

  const { data, isFetching } = useQuery({
    queryKey: ["detail-transaction-jwt", invoice_number, machineId],
    queryFn: () =>
      checkPaymentTransactionJwt({
        inv_number: invoice_number,
        uuid: machineId,
      }),
    enabled: !!(invoice_number && machineId),
    refetchOnWindowFocus: false,
  });

  const handleCopyInvoice = () => {
    navigator.clipboard.writeText(data && data.invoice);
    setCopied(true);
    showNotification("Nomor Invoice berhasil disalin!", "success");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-white relative">
      <div className="flex flex-row justify-center h-screen">
        <div className="w-full lg:w-1/2 flex justify-center lg:items-center px-0 lg:px-12 text-base">
          <div className="rounded-md py-4 px-3 lg:p-8 w-full h-fit">
            <div
              className={`bg-white fixed z-[9999] top-0 left-0 px-4 py-3 w-full flex flex-col items-center transition-all duration-300 ${
                isScrolled ? "shadow-md rounded-b-3xl" : ""
              }`}
            >
              <div className="flex flex-col w-full gap-4">
                <div className="w-full flex items-center gap-2 lg:hidden text-xl">
                  <div
                    onClick={() => {
                      navigate("/");
                    }}
                    className="p-1 hover:bg-gray-200 rounded-full"
                  >
                    <IoArrowBack className="text-gray-500" size={20} />
                  </div>
                  <p className="font-semibold text-slate-700">Pembayaran</p>
                </div>
              </div>
            </div>

            <div className="py-12 space-y-8">
              <div className="w-full flex items-center justify-center">
                <div className="flex flex-col items-center justify-center text-slate-700 px-4">
                  <img src={Success} alt="Success" className="w-1/2 mb-5" />
                  <h1 className="font-semibold text-lg text-center">
                    Pembayaran berhasil
                  </h1>
                  <p className="text-center text-md mt-2">
                    Pesananmu sedang disiapkan apotek.
                  </p>
                </div>
              </div>

              <div>
                <h1 className="font-medium mb-1 text-slate-700">
                  Invoice Number
                </h1>
                <div className="px-4 h-10 lg:h-12 lg:px-4 lg:py-2 rounded-lg bg-indigo-50 flex gap-2 items-center justify-between">
                  <p className="font-mono text-lg lg:text-lg font-semibold text-gray-800">
                    {data && data.invoice}
                  </p>
                  <button
                    onClick={handleCopyInvoice}
                    className="flex items-center gap-2 p-1 lg:px-3 lg:py-1 lg:border-2 text-primary rounded-full lg:rounded-lg hover:bg-indigo-100 transition-colors text-md cursor-pointer"
                  >
                    <IoMdCopy size={16} />
                    <p className="hidden lg:block">
                      {copied ? "Tersalin!" : "Salin"}
                    </p>
                  </button>
                </div>
              </div>

              <div className="flex flex-col gap-3">
                <button
                  type="submit"
                  onClick={() => {
                    navigate("/purchase/transaction-list");
                  }}
                  className="h-[40px] border border-secondary text-white bg-secondary flex items-center gap-2 justify-center w-full tracking-wide font-medium rounded-lg focus:outline-none focus:shadow-outline transform duration-200 hover:scale-100"
                >
                  Lihat Status Pesanan
                </button>
                <button
                  type="submit"
                  onClick={() => {
                    navigate("/");
                  }}
                  className="h-[40px] border border-slate-200 text-slate-500 bg-white flex items-center gap-2 justify-center w-full tracking-wide font-medium rounded-lg focus:outline-none focus:shadow-outline transform duration-200 hover:scale-100"
                >
                  Kembali ke Beranda
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPaymentSuccess;
